import {
  DocumentMatchCode,
  ExpirationDate,
  ImageQuality,
  Summary
} from "../types";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import CloseIcon from "shared/icons/status-icons/fail-icon.svg?react";
import InfoIcon from "shared/icons/status-icons/info-icon.svg?react";

export const GenericBadge = ({
  value
}: {
  value:
    | Summary
    | DocumentMatchCode
    | ImageQuality
    | ExpirationDate
    | string
    | null
    | undefined;
}) => {
  switch (value) {
    case Summary.PartialMatch:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.WARNING}
          className="items-center"
          leftElement={<InfoIcon className="text-warning-500 h-4 w-4" />}
        >
          Partial match
        </Badge>
      );
    case Summary.Match:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.SUCCESS}
          className="items-center"
          leftElement={<SuccessIcon className="text-success-500 h-4 w-4" />}
        >
          Match
        </Badge>
      );
    case Summary.NoMatch:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.ERROR}
          className="items-center"
          leftElement={<CloseIcon className="text-danger-500 h-4 w-4" />}
        >
          Failed
        </Badge>
      );
    case Summary.NoData:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.ERROR}
          className="items-center"
          leftElement={<CloseIcon className="text-danger-500 h-4 w-4" />}
        >
          No data
        </Badge>
      );
    case DocumentMatchCode.Match:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.SUCCESS}
          className="items-center"
          leftElement={<SuccessIcon className="text-success-500 h-4 w-4" />}
        >
          Match
        </Badge>
      );
    case DocumentMatchCode.PartialMatch:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.WARNING}
          className="items-center"
          leftElement={<InfoIcon className="text-warning-500 h-4 w-4" />}
        >
          Partial match
        </Badge>
      );
    case DocumentMatchCode.NoMatch:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.ERROR}
          className="items-center"
          leftElement={<CloseIcon className="text-danger-500 h-4 w-4" />}
        >
          Failed
        </Badge>
      );
    case DocumentMatchCode.NoData:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.ERROR}
          className="items-center"
          leftElement={<CloseIcon className="text-danger-500 h-4 w-4" />}
        >
          No data
        </Badge>
      );
    case ImageQuality.High:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.SUCCESS}
          className="items-center"
          leftElement={<SuccessIcon className="text-success-500 h-4 w-4" />}
        >
          High
        </Badge>
      );
    case ImageQuality.Medium:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.WARNING}
          className="items-center"
          leftElement={<InfoIcon className="text-warning-500 h-4 w-4" />}
        >
          Medium
        </Badge>
      );
    case ImageQuality.Low:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.ERROR}
          className="items-center"
          leftElement={<CloseIcon className="text-danger-500 h-4 w-4" />}
        >
          Low
        </Badge>
      );

    case ExpirationDate.Expired:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.ERROR}
          className="items-center"
          leftElement={<CloseIcon className="text-danger-500 h-4 w-4" />}
        >
          Expired
        </Badge>
      );
    case ExpirationDate.NotExpired:
      return (
        <Badge
          size={BadgeSize.BASE}
          variant={BadgeVariant.SUCCESS}
          className="items-center"
          leftElement={<SuccessIcon className="text-success-500 h-4 w-4" />}
        >
          Not expired
        </Badge>
      );
    case ExpirationDate.NoData:
      return (
        <Badge size={BadgeSize.BASE} variant={BadgeVariant.ERROR}>
          No data
        </Badge>
      );
    default:
      return null;
  }
};
